function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#748499",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M39 11h-5v20h5zM6 11H1v20h5z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FA6625",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M10 7h20v26H10z"
});
function SvgSingleQuestionViewQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default __webpack_public_path__ + "fonts/single-question-view-quiz-4baaff7032baff08b2defd4abefe28c6.svg";
export { SvgSingleQuestionViewQuiz as ReactComponent };